import { useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import dayjs from 'dayjs';
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';

const monthChoices = [
  {value: 1, label: 'January'}, 
  {value: 2, label: 'February'}, 
  {value: 3, label: 'March'}, 
  {value: 4, label: 'April'}, 
  {value: 5, label: 'May'}, 
  {value: 6, label: 'June'},
  {value: 7, label: 'July'}, 
  {value: 8, label: 'August'}, 
  {value: 9, label: 'September'}, 
  {value: 10, label: 'October'}, 
  {value: 11, label: 'November'}, 
  {value: 12, label: 'December'}
]

export default function DateFilter(props) {
  const { userParams, selectOptions, setUserParams, handleChange } = props;
  const [ hasDays, setHasDays ] = useState(false);

  const selectDayOptions = (choices) => {
    const month = choices === "fromFilterDay" ? userParams.fromFilterMonth : userParams.toFilterMonth;
    const dim = dayjs('2024-' + month.toString() + '-01').daysInMonth()
    // Changed length of array from dim to 31 to prevent warning when selected day is out of range
    const dayChoices = Array.from({length: 31}, (v, k) => k+1)
    return (
      dayChoices.map(option => {
        return (
          <MenuItem 
            dense={true}
            sx={{ pt:0, pb:0 }}
            key={option} 
            value={option}
            disabled={option > dim}   //disable out of range days
          >
            {option}
          </MenuItem>
        )
      })
    )
  }

  useEffect(() => {
    const hasDayProperty = userParams.hasOwnProperty('fromFilterDay') || userParams.hasOwnProperty('toFilterDay')
    setHasDays(hasDayProperty)
    if (hasDayProperty) {
      const fromdim = dayjs('2024-' + userParams.fromFilterMonth.toString() + '-01').daysInMonth()
      const todim = dayjs('2024-' + userParams.toFilterMonth.toString() + '-01').daysInMonth()
      // set out of range day selection to last day of month
      if (userParams.fromFilterDay > fromdim) {
        setUserParams({...userParams, fromFilterDay: fromdim});
      } else if (userParams.toFilterDay > todim) {
        setUserParams({...userParams, toFilterDay: todim});
      }
    }
  }, [userParams])


  return (
    <FieldsetBox component="fieldset" sx={{ mr: 2, mt:1 }}>
        <LegendStyled>Interval date range</LegendStyled>
        <Typography variant="body2" sx={{ mb: 1, fontStyle: 'italic' }}>
        For each year, use {hasDays ? "days" : "months"}:
        </Typography>
        <Stack direction="row" spacing={0}>
        <TextField sx={{ m:0 }}
            select
            name="fromFilterMonth"
            value={userParams.fromFilterMonth}
            onChange={(e) => handleChange(e,'integer')}
        >
            {selectOptions(monthChoices)}
        </TextField>
        {hasDays &&
          <TextField sx={{ m:0 }}
              select
              name="fromFilterDay"
              value={userParams.fromFilterDay}
              onChange={(e) => handleChange(e,'integer')}
          >
              {selectDayOptions("fromFilterDay")}
          </TextField>
        }
        <Typography variant="body2" sx={{ m: 1 }}>
            through
        </Typography>
        <TextField sx={{ m:0 }}
            select
            name="toFilterMonth"
            value={userParams.toFilterMonth}
            onChange={(e) => handleChange(e,'integer')}
        >
            {selectOptions(monthChoices)}
        </TextField>
        {hasDays &&
          <TextField sx={{ m:0 }}
              select
              name="toFilterDay"
              value={userParams.toFilterDay}
              onChange={(e) => handleChange(e,'integer')}
          >
              {selectDayOptions("toFilterDay")}
          </TextField>
        }
        </Stack>
    </FieldsetBox>
  )
}
